import {all, spawn} from 'redux-saga/effects';
import {onSubmitActions} from './common';
import formSubmitSaga from './form-submit-saga';

const factory = () => ({
  onSubmitActions,
  formSubmitSaga: formSubmitSaga(),

  addFormSubmitSagaTo (root) {
    if (!root) {
      return formSubmitSaga();
    }
    return function* formSubmitSagaComposed () {
      if (all) {
        yield all([
          spawn(root),
          spawn(formSubmitSaga())
        ]);
      } else {
        yield [
          spawn(root),
          spawn(formSubmitSaga())
        ];
      }
    };
  }

});

export default factory;
